<template>
	<q-card
		class="shadow-transition q-py-sm full-height card-activity relative-position cursor-pointer"
		:class="class_hover"
		@mouseover="setClassHover('mouseover')"
		@mouseleave="setClassHover('mouseleave')"
		@click="openActivity()"
	>
		<q-card-section>
			<div class="row q-col-gutter-md">
				<div class="col-8">
					<q-icon
						:name="$extensionIcon(activity.type_slug).icon"
						size="lg"
						:color="$extensionIcon(activity.type_slug).color"
					/>
				</div>

				<div class="col-4 text-right">
					<q-icon size="sm" :name="statusIcon" :color="statusColor" />
				</div>

				<div class="col-12">
					<span class="text-h5 title">
						{{ activity.type_title }}
					</span>
					<span class="text-grey-6">
						{{ $t($activityType(activity.type_slug)) }}
					</span>
				</div>
			</div>
		</q-card-section>

		<q-card-section class="text-grey-6 absolute-bottom" v-if="activity.score && $hasScore()">
			<q-icon size="xs" name="fal fa-trophy" color="grey-6" /> {{ activity.score }}
			{{ $t('point', { count: activity.score }) }}
		</q-card-section>

		<q-tooltip
			v-if="showTooltip"
			anchor="center middle"
			self="center middle"
			class="bg-primary"
			style="font-size: 16px"
		>
			{{ tooltipContent }}
		</q-tooltip>
	</q-card>
</template>

<script>
import { mapGetters } from 'vuex'
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
	name: 'WebinarActivity',

	props: ['activity', 'webcast'],

	data() {
		return {
			class_hover: '',
			hover: false,
		}
	},

	computed: {
		...mapGetters({
			webinar_status: 'webinars/webinar_status',
			full_name: 'common/full_name',
			email: 'common/email',
			id_user_client_selected: 'common/full_name',
			user_branches: 'common/user_branches',
			webcast_lounge_template: 'webinars/webcast_lounge_template',
		}),

		activityDisabled() {
			if (!this.webcast.webcast_user_subscribed) {
				return true
			} else {
				if (this.activity.hierarchy_order === 1) {
					let diff = this.$dateUtil.dateDiffereceTimezoneMinutes(this.activity.transmission_date)

					if (diff > 10) {
						if (
							this.$route.name == 'webinar_lounge' ||
							this.$route.name == 'trail_webinar_lounge'
						) {
							this.$emit('showModalTime', [])
							return true
						} else return true
					} else return false
				} else {
					if (this.webcast.status === 1) return true
					else if (
						(this.activity.hierarchy_order > 1 && !this.webcast.user_watch) ||
						this.activity.is_blocked
					)
						return true
				}
			}
		},

		statusIcon() {
			if (this.activity) {
				if (this.activity.hierarchy_order === 1) {
					if (this.webcast.user_watch) return 'fas fa-badge-check'
				} else {
					if (this.activity.user_watch || this.activity.date_approved) return 'fas fa-badge-check'
					else if (this.activity.is_blocked) return 'fas fa-ban'
					else if (
						this.activity.avaliable_in &&
						this.$dateUtil.dateDifferece(this.activity.avaliable_in) > 0
					)
						return 'fas fa-calendar-alt'
					else if (this.activity.has_requirement && this.activity.parent_title) return 'fas fa-lock'
				}
			}
			return ''
		},

		statusColor() {
			if (this.activity) {
				if (this.activity.hierarchy_order === 1) {
					if (this.webcast.user_watch) return 'positive'
				} else {
					if (this.activity.user_watch || this.activity.date_approved) return 'positive'
					else if (this.activity.is_blocked) return 'negative'
					else if (
						this.activity.avaliable_in &&
						this.$dateUtil.dateDifferece(this.activity.avaliable_in) > 0
					)
						return 'grey-6'
					else if (this.activity.has_requirement && this.activity.parent_title) return 'grey-6'
				}
			}
			return ''
		},

		showTooltip() {
			if (this.activity) {
				if (
					this.activity.avaliable_in &&
					this.$dateUtil.dateDifferece(this.activity.avaliable_in) > 0
				)
					return true
				else if (this.activity.has_requirement && this.activity.parent_title) return true
			}
			return false
		},

		tooltipContent() {
			if (this.activity) {
				if (
					this.activity.avaliable_in &&
					this.$dateUtil.dateDifferece(this.activity.avaliable_in) > 0
				) {
					return `${this.$t('available_in')}: ${this.$dateUtil.fDate(this.activity.avaliable_in)}`
				} else if (this.activity.has_requirement && this.activity.parent_title) {
					return `${this.$t('requirement')}: ${this.activity.parent_title}`
				}
			}
			return ''
		},
		projectName() {
			return process.env.PROJECT_NAME
		},
	},

	methods: {
		openActivity() {
			if (!this.webcast.webcast_user_subscribed) {
				this.confirmSubscribeWebinar()
			} else {
				if (this.activity.webcast_type && this.activity.webcast_type === 4) {
					let arrayName = this.full_name.trim().split(' ')
					let firtName = arrayName[0]
					let lastName = arrayName[arrayName.length - 1]

					let client =
						this.user_branches && this.user_branches.length > 0
							? this.user_branches[0].name.split(' ').join('')
							: this.projectName.split(' ').join('')

					window.open(
						`${this.activity.embed}?Std1=${firtName}&Std2=${lastName}&Std3=${client}&Std4=${this.email}`,
						'_blank'
					)
					this.openWebinar(this.activity.id)
				} else {
					if (!this.activityDisabled) {
						this.$store.dispatch('utils/SET_ROUTE_FROM', this.$route.name)
						if (this.webcast_lounge_template) {
							if (this.$route.name !== 'trail_webinar_lounge')
								this.$router.push({
									name: 'webinar_activity',
									params: {
										id: this.$route.params.id,
										hierarchy_order: this.activity.hierarchy_order,
									},
								})
							else {
								this.$store.dispatch('utils/SET_ROUTE_FROM', this.$route.name)
								this.$router.push({
									name: 'trail_webinar_activity',
									params: {
										id_trail: this.$route.params.id_trail,
										id: this.$route.params.id,
										hierarchy_order: this.activity.hierarchy_order,
									},
								})
							}
						} else {
							if (this.$route.name !== 'trail_webinar')
								this.$router.push({
									name: 'webinar_activity',
									params: {
										id: this.$route.params.id,
										hierarchy_order: this.activity.hierarchy_order,
									},
								})
							else
								this.$router.push({
									name: 'trail_webinar_activity',
									params: {
										id_trail: this.$route.params.id_trail,
										id: this.$route.params.id,
										hierarchy_order: this.activity.hierarchy_order,
									},
								})
						}
					}
				}
			}
		},

		openWebinar(id) {
			let url =
				this.$route.name !== 'trail_webinar'
					? `/etraining_webcasts/webcasts/${id}/open_webcast/`
					: `/etraining_trails/trail/${this.$route.params.id_trail}/webcast/${id}/open_webcast/`

			this.$axios
				.get(url)
				.then((response) => {})
				.catch((e) => {
					console.log(e)
				})
		},

		confirmSubscribeWebinar() {
			this.$emit('confirmSubscribeWebinar', this.webcast.id)
		},

		setClassHover(state) {
			if (this.activityDisabled) this.class_hover = 'disabled'
			else {
				if (state === 'mouseover') this.class_hover = 'shadow-5'
				else this.class_hover = ''
			}
		},
	},

	created() {
		if (this.activityDisabled) this.class_hover = 'disabled'
	},
}
</script>

<style lang="scss" scoped>
.title {
	font-size: 0.905rem;
	font-weight: 800;
	line-height: 1.2rem;
	min-height: 57px;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.card-activity {
	min-height: 250px;
}
</style>
